import React from "react";
import { useTranslation } from "next-i18next";
import ConfirmModal from "./ConfirmModal";

export default function OpenAccountModal({
	visible,
	onClose,
	onConfirm,
}: {
	visible: boolean;
	onClose: () => void;
	onConfirm: () => void;
}) {
	const { t } = useTranslation("common");

	return (
		<ConfirmModal
			visible={visible}
			onClose={onClose}
			title={t("account-required")}
			onCancelText={t("later")}
			onCancel={onClose}
			onOkText={t("go-now")}
			onOk={onConfirm}
		>
			{t("you-need-to-open-an-account-first")}
		</ConfirmModal>
	);
}
